<template>
  <div class="v-subscription-address-update-modal">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">
            <h5>Редактировать информацию о подписке</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <div v-if="this.loading">
              <div class="d-flex justify-content-center">
                <div class="spinner-grow m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else class="py-3">
              <form class="form" @submit.prevent="updateSubscriptionAddress" autocomplete="nope">
                <div class="row mx-3">
                  <div class="col-lg-12 pb-3">
                    <div class="form-group" v-bind:class="[ this.inputs.address  ? 'filled' : '' ]">
                      <input class="form-control"
                             required id="subscription-address" v-model="inputs.address"
                             @focusin="InputFocusIn('subscription-address')"
                             @focusout="InputFocusOut('subscription-address')"/>
                      <label for="subscription-address">Адрес подписки</label>
                    </div>
                  </div>
                </div>
                <div class="row mx-3 pt-3">
                  <div class="col-12">
                    <button type="submit" class="btn btn-primary">
                      Обновить адрес
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'v-subscription-address-update-modal',
  props: ['subscriptionId', 'subscriptionAddress'],
  data() {
    return {
      loading: true,
      inputs: {
        address: '',
      },
    };
  },
  computed: {
    ...mapState('subscription', ['subscriptionCreateUpdateError']),
  },
  methods: {
    ...mapActions('subscription', ['updateSubscription']),
    close() {
      this.$emit('close');
    },
    updateSubscriptionAddress() {
      const newData = { subscriptionId: this.subscriptionId, data: this.inputs };
      this.updateSubscription(newData)
        .then(() => {
          if (!this.subscriptionCreateUpdateError) {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'success',
              text: 'Подписка успешно обновлена!',
            });
          } else {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'error',
              text: 'Произошла ошибка!',
            });
          }
        })
        .finally(() => { this.close(); });
    },
  },
  created() {
    this.inputs.address = this.subscriptionAddress;
    this.loading = false;
  },
};
</script>
